module.exports = __webpack_public_path__ + "static/media/publish-videos.65287f0a.webp";